import { useApi } from "utils";

type GenerateLinkTransactionParams = {
  api: ReturnType<typeof useApi>;
  data_source: number;
  data_source_id: number;
};

export const generateLinkTransaction = async ({
  api,
  data_source,
  data_source_id
}: GenerateLinkTransactionParams) => {

  if (data_source === 6) {
    const generated_path = await api.get(`probill/detailbill?bill_id=${data_source_id}`).then(res => {
      const purchase_order_id = res.data.payload.databill.purchase_order_id
      return `/purchase/transaction/enter-bills/${purchase_order_id}/edit/${data_source_id}`
    })

    return generated_path;
  }

  if (data_source === 9) {
    const generated_path = await api.get(`/paymentbill/datapayment_by_payment_id`, {params: { payment_bill_id: data_source_id }}).then(res => {
      const source_type = res.data.payload.source_type
      const url = source_type === 1
        ? `/purchase/transaction/payment-bill/edit/${data_source_id}`
        : `/purchase/transaction/payment-bill-service/edit/${data_source_id}`
      
      return url
    })

    return generated_path;
  }



  switch (data_source) {
    case 1:
      return `/finance/transaction/spend-money/edit/${data_source}/${data_source_id}`;
    case 2:
      return `/finance/transaction/receive-money/edit/${data_source}/${data_source_id}`;
    case 3:
      return `/finance/transaction/general-entry/edit/${data_source}/${data_source_id}`;
    case 4:
      return `/finance/transaction/transfer-money/edit/${data_source}/${data_source_id}`;
    case 5:
      return `/purchase/transaction/purchase-order/${data_source_id}`;
    case 7:
      return `/purchase/transaction/deposit-vendor/edit/${data_source_id}`;
    case 8:
      return `/accounts/transaction/opening-balance`;
    case 10:
      return `/sales/transaction/customer-order/edit/${data_source_id}`;
    case 11:
      return `/sales/transaction/invoice/edit/${data_source_id}`;
    case 12:
      return `/sales/transaction/payment-deposit/edit/${data_source_id}`;
    case 13:
      return `/sales/transaction/payment-invoice/edit/${data_source_id}`;
    case 14:
      return `/setup/inventory/opening-stock/update/${data_source_id}`;
    case 18:
      return `/purchase/transaction/reject-item/edit/${data_source}/${data_source_id}`;
    case 20:
      return `/sales/transaction/return-items/edit/${data_source_id}`;
    case 22:
      return `/inventory/transaction/transfer-items/edit/${data_source_id}`;
    case 24:
      return `/inventory/transaction/received/edit/${data_source_id}`;
    case 27:
      return `/inventory/transaction/adjustment-inventory/edit/${data_source_id}`
    case 32:
      return `/sales/transaction/customer-quotation/edit/${data_source_id}`;
    case 34:
      return `/purchase/transaction/received-reject/data-source/${data_source_id}`;
    case 36:
      return `/inventory/transaction/build-item/edit/${data_source_id}`;
    case 38:
      return `/asset-management/transaction/profile-asset/${data_source_id}`;
    case 46:
      return `/purchase/transaction/bill-service/${data_source_id}`;
    default:
      return "/";
  }
};
